import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { Context, Transitions } from "../types"
import { getServiceErrorMessage } from "../helpers"

export const removeLessonTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    src: "removeSectionItemByContentId",
    onDone: [
      {
        target: "#StudyPlan.edit_plan.go_back_to_previous",
        cond: "checkSelectedSection",
        actions: "onRemoveLesson"
      },
      // If selected section does not exist anymore, go to "edit_plan.idle" state.
      // Deselect current section and close "add_lesson" modal.
      {
        target: "#StudyPlan.edit_plan.idle",
        actions: [
          "onRemoveLesson",
          assign<Context, DoneInvokeEvent<any>>({
            addLessonModal: false
          })
        ]
      }
    ],
    onError: {
      target: "#StudyPlan.edit_plan.go_back_to_previous",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, evt) => ({
          message: getServiceErrorMessage("removeSectionItem", {
            errorReason: evt.data.message
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
